import authApiService from './userApiService';

const handleError = (error) => {
  console.error('Tournament tag API error:', error);
  return {
    success: false,
    error:
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      'An unexpected error occurred',
    statusCode: error.response?.status,
  };
};

export const dashboardTournamentTagService = {
  async getOverrides() {
    try {
      const response = await authApiService.get('/dashboard-tournament-tags');
      return {
        success: true,
        overrides: response.data?.overrides || {},
        tags: response.data?.tags || [],
      };
    } catch (error) {
      return handleError(error);
    }
  },

  async setOverride(gameName, isTournament) {
    try {
      const response = await authApiService.put('/dashboard-tournament-tags', {
        gameName,
        isTournament,
      });
      return {
        success: true,
        tag: response.data?.tag,
        message: response.data?.message,
      };
    } catch (error) {
      return handleError(error);
    }
  },
};
